import React from "react";
import { FEATURES } from "../data/copperx";
import { ShieldCheck, Sparkles, Ruler, Layers, Wind, Activity } from "lucide-react";

const ICONS = [ShieldCheck, Sparkles, Ruler, Layers, Wind, Activity];

const QUALITY_IMG =
  "https://images.pexels.com/photos/3721272/pexels-photo-3721272.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function WhyCopperX() {
  return (
    <section
      id="why"
      data-testid="why-copperx-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
            <div className="flex items-center gap-3 mb-5">
              <span className="section-rule" />
              <span className="text-[#B85C38] text-xs tracking-[0.3em] uppercase font-semibold">
                Why CopperX
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-[#0F172A] leading-[1.05] mb-8">
              The technical edge that <span className="text-[#B85C38]">specifying engineers</span> demand.
            </h2>
            <p className="text-[#475569] text-lg leading-relaxed mb-8">
              High-performance ACR tube engineered for the demands of modern HVAC-R —
              from VRF systems to high-pressure refrigerants like R410A.
            </p>
            <div className="relative h-64 overflow-hidden">
              <img
                src={QUALITY_IMG}
                alt="Close-up copper texture — quality"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-[#B85C38]/20 mix-blend-multiply" />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#E2E8F0]">
              {FEATURES.map((f, idx) => {
                const Icon = ICONS[idx] || ShieldCheck;
                return (
                  <div
                    key={f.title}
                    data-testid={`feature-card-${idx}`}
                    className="bg-white p-8 md:p-10 hover:bg-[#F8F9FA] transition-colors group"
                  >
                    <div className="flex items-start gap-4 mb-4">
                      <div className="bg-[#18181B] text-[#E19672] p-3 group-hover:bg-[#B85C38] group-hover:text-white transition-colors">
                        <Icon size={20} strokeWidth={1.6} />
                      </div>
                      <div className="font-mono text-xs text-[#B85C38] tracking-wider pt-3">
                        0{idx + 1}
                      </div>
                    </div>
                    <h3 className="text-xl font-medium text-[#0F172A] mb-3" style={{ fontFamily: "Outfit, sans-serif" }}>
                      {f.title}
                    </h3>
                    <p className="text-[#475569] text-sm leading-relaxed">
                      {f.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
